import { GlobalConfig } from '@stylesheet/config/Global'
import Color from 'color'
import { ADMIN_COLORS } from '@stylesheet/brands/ikh/admin/Colors'

export const GLOBAL_CONFIG: GlobalConfig = {
    profileImgPlaceholder: {
        background: ADMIN_COLORS.gray_200
    },
    sidebar: {
        main: {
            background: ADMIN_COLORS.white,
            separator: ADMIN_COLORS.gray_200,
            text: ADMIN_COLORS.gray_300,
            primary: ADMIN_COLORS.dark,
            primarySelected: ADMIN_COLORS.darkSelected,
            navLink: {
                active: {
                    background: ADMIN_COLORS.gray_200
                }
            },
            shadow: ADMIN_COLORS.shadowColor3
        },
        top: {
            background: ADMIN_COLORS.white,
            separator: ADMIN_COLORS.gray_200,
            text: ADMIN_COLORS.gray_300,
            primary: ADMIN_COLORS.dark,
            primarySelected: ADMIN_COLORS.darkSelected,
            shadow: ADMIN_COLORS.shadowColor3
        },
        bottom: {
            background: ADMIN_COLORS.white,
            separator: ADMIN_COLORS.gray_200,
            text: ADMIN_COLORS.gray_300,
            primary: ADMIN_COLORS.dark,
            primarySelected: ADMIN_COLORS.darkSelected,
            shadow: ADMIN_COLORS.shadowColor3
        }
    },
    body: {
        background: ADMIN_COLORS.white,
        fontFamily: 'Ikh-Admin'
    },
    versionControl: {
        color: ADMIN_COLORS.dark
    },
    overlayText: {
        background: `${ Color(ADMIN_COLORS.gray_500).alpha(0.5).rgb().toString() }`,
        color: ADMIN_COLORS.dark
    },
    fullscreenOverlay: {
        background: `${ Color(ADMIN_COLORS.black).alpha(0.5).rgb().toString() }`,
        color: ADMIN_COLORS.white
    },
    toastifyToastDefault: {
        background: ADMIN_COLORS.black
    },
    toastifyToastInfo: {
        background: ADMIN_COLORS.gray_200,
        color: ADMIN_COLORS.white
    },
    toastifyToastSuccess: {
        background: ADMIN_COLORS.green,
        color: ADMIN_COLORS.white
    },
    toastifyToastWarning: {
        background: ADMIN_COLORS.yellow1,
        color: ADMIN_COLORS.white
    },
    toastifyToastError: {
        background: ADMIN_COLORS.red,
        color: ADMIN_COLORS.white
    },
    webkitScrollbarThumb: {
        backgroundColor: ADMIN_COLORS.gray_300
    },
    reactDatepicker: {
        borderColor: ADMIN_COLORS.gray_200,
        backgroundColor: ADMIN_COLORS.white,
        textColor: ADMIN_COLORS.black
    },
    formFloaticon: {
        hoverColor: ADMIN_COLORS.blue_200
    },
    datePickerArrows: {
        borderColor: ADMIN_COLORS.blue_200,
        color: ADMIN_COLORS.blue_200
    },
    datePickerText: {
        color: ADMIN_COLORS.black
    },
    datePickerDay: {
        color: ADMIN_COLORS.black
    },
    datePickerSelected: {
        backgroundColor: ADMIN_COLORS.yellow1,
        color: ADMIN_COLORS.white
    },
    datePickerSelectingRange: {
        backgroundColor: `${ Color(ADMIN_COLORS.yellow1).alpha(0.5).rgb().toString() }`,
        color: ADMIN_COLORS.black
    },
    datePickerRange: {
        backgroundColor: ADMIN_COLORS.gray_300,
        color: ADMIN_COLORS.black
    },
    datePickerHover: {
        backgroundColor: ADMIN_COLORS.gray_300
    },
    datePickerSelect: {
        borderRadius: '0.3em',
        backgroundColor: 'transparent',
        color: ADMIN_COLORS.black
    },
    datePickerSelectOption: {
        backgroundColor: ADMIN_COLORS.gray_300,
        color: ADMIN_COLORS.black
    },
    timeListItemHover: {
        backgroundColor: ADMIN_COLORS.gray_300
    },
    dayName: {
        color: ADMIN_COLORS.gray_400
    },
    timeInput: {
        color: ADMIN_COLORS.black
    },
    sliderHandleDragging: {
        borderColor: ADMIN_COLORS.gray_300,
        boxShadow: `0 0 0 0 ${ ADMIN_COLORS.gray_300 }`
    },
    sliderHandleHover: {
        borderColor: ADMIN_COLORS.gray_300
    },
    sliderTrack: {
        backgroundColor: ADMIN_COLORS.yellow1
    },
    sliderHandle: {
        borderColor: `solid 1.5px ${ ADMIN_COLORS.gray_300 }`
    },
    sliderMarkText: {
        color: ADMIN_COLORS.black
    },
    sliderDot: {
        borderColor: ADMIN_COLORS.yellow1
    },
    sliderDisabled: {
        backgroundColor: 'transparent'
    },
    tag: {
        color: ADMIN_COLORS.black,
        backgroundColor: ADMIN_COLORS.white,
        boxShadow: `0px 2px 10px 0px ${ ADMIN_COLORS.shadowColor3 }`
    },
    formSwitch: {
        backgroundColor: ADMIN_COLORS.gray_400,
        borderColor: 'transparent'
    },
    pageLinkSettingsSwitchWrapper: {
        borderTopColor: ADMIN_COLORS.gray_200,
        borderBottomColor: ADMIN_COLORS.gray_200
    },
    passwordStrengthMeter: {
        backgroundColor: ADMIN_COLORS.gray_200,
        activeBackgroundColor: ADMIN_COLORS.yellow1
    },
    dropdownList: {
        borderColor: ADMIN_COLORS.gray_200,
        option: {
            boxShadow: `0px 5px 15px 0px ${ ADMIN_COLORS.shadowColor2 }`,
            selected: {
                background: ADMIN_COLORS.gray_200
            }
        },
        backgroundColor: ADMIN_COLORS.white,
        searchBox: {
            borderColor: ADMIN_COLORS.yellow2,
            boxShadow: `0 0 0 0.25rem ${ ADMIN_COLORS.yellowShadow }`,
            backgroundColor: ADMIN_COLORS.white,
            input: {
                background: 'inherit'
            },
            icon: {
                color: ADMIN_COLORS.black
            }
        }
    },
    modal: {
        bg: ADMIN_COLORS.white,
        color: ADMIN_COLORS.dark
    }
}
